export const DOCUMENT_KINDS = {
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  IPID: 'IPID',
  BACKMARKET_RECAP: 'BACKMARKET_RECAP',
}
